import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

import { SideNav } from './side-nav.model';


@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  animations: [
    trigger('rotateIcon', [
      state(
        'expand',
        style({
          transform: 'rotate(180deg)'
        })
      ),
      state(
        'collapse',
        style({
          transform: 'none'
        })
      ),
      transition('* => *', [animate('400ms')])
    ])
  ]
})
export class SideNavComponent implements OnInit {

  @Input() sideNavItems: SideNav[] = [];
  @Input() isMenuExpanded = false;
  @Input() cssClass = '';
  @Input() sideNavRef: MatSidenav = {} as any;
  @Input() coloredIcons = false;
  @Input() homeRouteLink = 'asas';
  @Input() menuType: 'grey' | 'primary' = 'primary';
  @Input() menuExpandState = '';
  @Output() expandColapseMenu = new EventEmitter();
  isMenuOpened = true;

  constructor() { }

  ngOnInit() { }


  expandCollapseMenu() {
    this.isMenuOpened = !this.isMenuOpened;
    this.expandColapseMenu.emit();
  }
}
